<template>
  <v-card>
    <v-card-title class="headline">Unsaved Annotations</v-card-title>
    <v-card-text>
      There are {{ unsavedAmount }} unsaved annotation(s).
      Are you sure you want to close out your annotating session?
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="close">Cancel</v-btn>
      <v-btn text color="primary" @click="confirmCancel">Confirm</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'UnsavedAnnotationsConfirm',
  props: ['unsavedAmount'],
  methods: {
    close() { this.$emit('closeConfirm'); },
    confirmCancel() { this.$emit('closeAnnotate'); },
  },
};
</script>
